export default "__VITE_ASSET__B7benW$e__"